import callImage from "../../images/LandingPageImage/cta_img_1x.webp";

const LandingCta = () => {
  return (
    <section className="bg-green-50 py-12 px-4">
      <div className="max-w-7xl mx-auto bg-white rounded-2xl overflow-hidden">
        <div className="flex flex-col lg:flex-row items-center">
          {/* Left Content */}
          <div className="w-full lg:w-1/2 p-6 sm:p-10">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-gray-800 leading-snug">
              Maximize your Advertising ROI,
            </h2>

            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-gray-800 leading-snug mt-2">
              Transform Clicks into Captivating Conversations!
            </h2>

            <p className="text-gray-600 mt-6 text-base sm:text-lg">
              Unleash Quality Leads, Nurture, and Interact through WhatsApp
              after Clicks!
            </p>
          </div>

          {/* Right Image */}
          <div className="w-full lg:w-1/2 flex justify-center items-center p-6 sm:p-10">
            <img
              loading="lazy"
              src={callImage}
              alt="CTA Illustration"
              className="w-64 sm:w-80 lg:w-96 object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingCta;
